import script from "./CategoryAttributeOptionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryAttributeOptionPage.vue?vue&type=script&setup=true&lang=js"

import "./CategoryAttributeOptionPage.vue?vue&type=style&index=0&id=03d0a5ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03d0a5ec"]])

export default __exports__